import { render, staticRenderFns } from "./auth-admin.form.vue?vue&type=template&id=7597f426&"
import script from "./auth-admin.form.vue?vue&type=script&lang=ts&"
export * from "./auth-admin.form.vue?vue&type=script&lang=ts&"
import style0 from "./auth-admin.form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports